module.exports = __webpack_public_path__ + "static/media/icDoctor_white.ff8988f0.svg";